import React from 'react';
import { Box, ExpressSetupDangerIcon, ExpressSetupDoneIcon, Inscription, PencilIcon, RawButton } from '@common-fe/common-fe';

import { RenewalSetupStepTitle } from '../RenewalSetup.types';

interface Props {
  title: RenewalSetupStepTitle;
  isSuccessMode: boolean;
  onEdit?: () => void;
  children?: React.ReactNode;
}

const ContainerItem: React.FC<Props> = ({
  title,
  isSuccessMode,
  onEdit,
  children
}) => (
  <Box background={isSuccessMode ? 'successContainer' : 'dangerContainer'} pad="l" round="container1Round" width="100%" data-testid="container-item">
    <Box direction="row" align="center" justify="between" margin={{ bottom: 's' }}>
      <Box direction="row" align="center" gap="s">
        {isSuccessMode ? <ExpressSetupDoneIcon size="32px" color="success" /> : <ExpressSetupDangerIcon />}
        <Inscription weight="bold" size="large" lineHeight="22px" color="textBody">{title}</Inscription>
      </Box>
      {onEdit && (
        <RawButton data-testid="container-item_edit-button" onClick={onEdit}>
          <PencilIcon size="24px" color="iconPrimary" />
        </RawButton>
      )}
    </Box>
    {children}
  </Box>
);

export default ContainerItem;
